import React, { useCallback, useEffect, useRef, useState } from "react";
import Button from "@client.components/Button";
import ServiceProvider from "@client.services/provider";
import Loader from "@client.components/Loader";
import classNames from "classnames";
import "./Modal.scss";

export const MODAL_EVENT = "Modal";

const DEFAULT_SETTINGS = {
  show: false,
  title: "",
  component: null,
  withBodyRef: false,
  onClose: null,
  contentClass: "",
  buttonSettings: null,
};

export const Modal = () => {
  const [settings, setSettings] = useState(DEFAULT_SETTINGS);
  const [isLoading, setIsLoading] = useState(false);

  const closePopup = useCallback(() => {
    if (settings.onClose) {
      settings.onClose();
    }
    setSettings(DEFAULT_SETTINGS);
  }, [settings]);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.keyCode === 27) {
        closePopup();
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    ServiceProvider.EventEmitter.on(MODAL_EVENT, (payload) => {
      setSettings(payload);
    });
    return () => {
      ServiceProvider.EventEmitter.removeAllListeners(MODAL_EVENT);
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [closePopup]);

  const modalBodyRef = useRef(null);
  const buttonRef = useRef(null);
  const buttonClick = async (onClick) => {
    setIsLoading(true);

    await onClick(modalBodyRef.current, buttonRef.current);

    setIsLoading(false);
  };

  return (
    settings.show && (
      <div className="modal">
        <div className="modal-backdrop" onClick={closePopup}></div>
        <div className={classNames("modal-content", settings.contentClass)}>
          <div className="modal-title">
            {settings.title}
            <Button
              icon="close"
              className="modal-close-button"
              onClick={closePopup}
            />
          </div>
          <div className="modal-body">
            {isLoading && (
              <div className="load-holder">
                <Loader loading={true} />
              </div>
            )}
            {settings.withBodyRef
              ? React.cloneElement(settings.component, {
                  ref: modalBodyRef,
                })
              : settings.component}
            {!!settings.buttonSettings?.length && (
              <div className="modal-footer">
                {settings.buttonSettings.map((btn, index) => (
                  <Button
                    {...btn}
                    key={`footer-btn-${index}`}
                    disabled={isLoading}
                    ref={buttonRef}
                    onClick={() => buttonClick(btn.onClick)}
                  />
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    )
  );
};
